import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'

import { IDocumentModel } from './typings'
import { StoreData } from '../reducers/typings'

import { getLocationDocuments } from './api'

const locationDocumentsAdapter = createEntityAdapter<IDocumentModel>({
  selectId: (locationDoc) => locationDoc.documentId,
  sortComparer: (a, b) => a.name.localeCompare(b.name),
})

export const initialState = locationDocumentsAdapter.getInitialState()

export const locationDocumentsSlice = createSlice({
  name: 'attachments',
  initialState: initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getLocationDocuments.fulfilled, (state, { payload }) => {
      payload.map((p) => (p.date = new Date(p.date)))
      locationDocumentsAdapter.setAll(state, payload)
    })
  },
})

export default locationDocumentsSlice.reducer

export const locationDocumentsSelectors =
  locationDocumentsAdapter.getSelectors<StoreData>(
    (state) => state.locationDocuments,
  )

export const selectLocationDocumentsSlice = (state: StoreData) => {
  return state.locationDocuments
}

export const {
  selectById: selectLocationDocumentById,
  selectAll: selectAllLocationDocuments,
} = locationDocumentsSelectors

export const { reset } = locationDocumentsSlice.actions
